var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.896,
    height: 22.196,
    viewBox: "0 0 19.896 22.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(-1025.962 -224.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6513",
    "data-name": "Path 6513",
    d: "M1035.906,246.886c-2.232,0-4.466-.041-6.7.013a3.19,3.19,0,0,1-3.233-3.539,6.544,6.544,0,0,1,6.685-6.146q3.254-.008,6.506,0a6.5,6.5,0,0,1,6.451,4.9,3.955,3.955,0,0,1-.208,3.211,3,3,0,0,1-2.657,1.558h-6.848Zm-.03-1.693q3.366,0,6.73,0a1.431,1.431,0,0,0,1.519-1.373,4.757,4.757,0,0,0-4.435-4.85q-3.78-.106-7.566,0a4.758,4.758,0,0,0-4.446,4.573,1.452,1.452,0,0,0,1.619,1.652Q1032.586,245.2,1035.876,245.193Z",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6514",
    "data-name": "Path 6514",
    d: "M1035.9,224.7a5.406,5.406,0,1,1-5.4,5.384A5.39,5.39,0,0,1,1035.9,224.7Zm3.673,5.412a3.676,3.676,0,1,0-3.711,3.682A3.7,3.7,0,0,0,1039.577,230.116Z",
    fill: "#7e97b8",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.6514e92e003789b5b07b8827f3079674.svg";
export { ForwardRef as ReactComponent };